let theme = {
  dark: 'Tema Escuro',
  light: 'Tema Claro'
}

export default theme
